import FormValidityCreate from './FormValidityCreate';
import FormValidityDelete from './FormValidityDelete';
import FormValidityFilter from './FormValidityFilter';
import FormValidityUpdate from './FormValidityUpdate';

export default Object.assign(
  {},
  {
    Create: FormValidityCreate,
    Update: FormValidityUpdate,
    Delete: FormValidityDelete,
    Filter: FormValidityFilter,
  },
);
